export const CREATE_NOTIFY = {
  path: "notify/createNotify",
  method: "POST",
  requestBody: {
    emailCustomer: "testemailcustomer@test.com",
    emailSupplier: "testemailsupplier@test.com",
    alreadySent: false, //false: email non ancora inviata, true: email inviata
    text: "text",
    customerName: "test",
    supplierName: "matteo",
  },
};

export const EP_GET_ALL_NOTIFY = {
  path: "notify",
  method: "GET",
};

export const EP_UPDATE_NOTIFY = {
  path: "notify/updateNotify",
  method: "PATCH",
};

export const EP_DELETE_NOTIFY = {
  path: "notify/deleteNotify",
  method: "DELETE",
};
